import type { FloraHeroTopic } from '../../types/flora-ai.types';
import styles from './FloraHeroSection.module.css';

interface FloraHeroSectionProps {
	firstDocumentName: string;
	topics: FloraHeroTopic[];
	onTopicClick?: (topic: FloraHeroTopic) => void;
}

export const FloraHeroSection = ({ firstDocumentName, topics, onTopicClick }: FloraHeroSectionProps) => {
	return (
		<section className={styles.section}>
			<h2 className={styles.heading}>
				Tudo que está no dossiê, <br className={styles.lineBreak} />
				a Flora <em className={styles.emphasis}>já leu.</em>
			</h2>
			<p className={styles.description}>
				Ela responde a partir de <strong className={styles.fileName}>{firstDocumentName}</strong> e mais 1 e
				devolve a página de onde tirou cada número. Tire uma folha do dossiê e ela para de considerá-la.
			</p>
			<ul className={styles.topics}>
				{topics.map((topic) => (
					<li key={topic.id}>
						<button type="button" className={styles.topicButton} onClick={() => onTopicClick?.(topic)}>
							<span className={styles.topicNumber}>{topic.number}</span>
							<span className={styles.topicLabel}>{topic.label}</span>
						</button>
					</li>
				))}
			</ul>
		</section>
	);
};
